import gql from 'graphql-tag';
export const LOGIN_WITH_TOKEN_MUTATION = gql`
  mutation loginWithToken($token: String!) {
    loginWithToken(token: $token) {
      token
      defaultPage
    }
  }
`;
